'use client'
import Header from '@/components/layout/main/header'
import Footer from '@/components/layout/main/footer/Footer'

export default function Layouts({ children }) {
  return (
    <>
      <div className="min-h-screen lg:h-[100vh]">
        <Header />
        <div id="inner-layout">{children}</div>
        <Footer />
      </div>
    </>
  )
}
